import React, { useState, useEffect, useRef } from 'react';
import api from '../api';

function eur(v) { return v ? `${parseFloat(v).toFixed(2)} €` : ''; }

export default function VorratPage() {
  const [vorrat, setVorrat] = useState([]);
  const [kategorien, setKategorien] = useState([]);
  const [listen, setListen] = useState([]);
  const [zeigForm, setZeigForm] = useState(false);
  const [bearbeite, setBearbeite] = useState(null);
  const [form, setForm] = useState({ name: '', barcode: '', marke: '', kategorie_id: '', menge: '0', einheit: 'Stück', mindestbestand: '1', haltbarkeit: '', lagerort: 'Vorratskammer', preis: '', auto_einkauf: false });
  const [filter, setFilter] = useState('alle');
  const [scan, setScan] = useState('');
  const [zeigScanner, setZeigScanner] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => { laden(); }, []);

  async function laden() {
    const [v, k, l] = await Promise.all([api.get('/vorrat'), api.get('/kategorien'), api.get('/listen')]);
    setVorrat(v.data);
    setKategorien(k.data);
    setListen(l.data);
  }

  async function speichern(e) {
    e.preventDefault();
    if (bearbeite) await api.put(`/vorrat/${bearbeite}`, form);
    else await api.post('/vorrat', form);
    setZeigForm(false); setBearbeite(null);
    setForm({ name: '', barcode: '', marke: '', kategorie_id: '', menge: '0', einheit: 'Stück', mindestbestand: '1', haltbarkeit: '', lagerort: 'Vorratskammer', preis: '', auto_einkauf: false });
    laden();
  }

  async function loeschen(id) {
    if (!window.confirm('Löschen?')) return;
    await api.delete(`/vorrat/${id}`);
    laden();
  }

  async function mengeAendern(id, delta) {
    const item = vorrat.find(v => v.id === id);
    const neueMenge = Math.max(0, (item.menge || 0) + delta);
    await api.patch(`/vorrat/${id}/menge`, { menge: neueMenge });
    laden();
  }

  async function autoEinkauf() {
    if (listen.length === 0) { alert('Erst eine Einkaufsliste erstellen!'); return; }
    const r = await api.post('/vorrat/auto-einkauf', { liste_id: listen[0].id });
    alert(`${r.data.hinzugefuegt} Artikel zur Liste "${listen[0].name}" hinzugefügt!`);
  }

  async function kameraScanner() {
    setZeigScanner(true);
    await new Promise(r => setTimeout(r, 600));
    try {
      const { BrowserMultiFormatReader } = await import('@zxing/library');
      const codeReader = new BrowserMultiFormatReader();
      const videoEl = videoRef.current;
      if (!videoEl) { setZeigScanner(false); return; }
      await codeReader.decodeFromConstraints(
        { video: { facingMode: 'environment' } },
        videoEl,
        (result, err) => {
          if (result) {
            codeReader.reset();
            setZeigScanner(false);
            barcodeEingabe(result.getText());
            setZeigForm(true);
          }
        }
      );
      window._zxingReaderVorrat = codeReader;
    } catch(e) {
      setZeigScanner(false);
      alert('Kamera Fehler: ' + (e.message || 'Unbekannt'));
    }
  }

  async function barcodeEingabe(code) {
    if (!code) return;
    try {
      const r = await api.get(`/barcode/${code}`);
      setForm(f => ({ ...f, name: r.data.name || f.name, marke: r.data.marke || f.marke, barcode: code }));
    } catch {}
  }

  function bearbeiten(item) {
    setForm({ name: item.name, barcode: item.barcode||'', marke: item.marke||'', kategorie_id: item.kategorie_id||'',
      menge: item.menge||'0', einheit: item.einheit||'Stück', mindestbestand: item.mindestbestand||'1',
      haltbarkeit: item.haltbarkeit||'', lagerort: item.lagerort||'Vorratskammer', preis: item.preis||'', auto_einkauf: item.auto_einkauf===1 });
    setBearbeite(item.id);
    setZeigForm(true);
  }

  const heute = new Date().toISOString().split('T')[0];
  const in7 = new Date(); in7.setDate(in7.getDate() + 7);

  const gefilter = vorrat.filter(v => {
    if (filter === 'niedrig') return v.menge <= v.mindestbestand;
    if (filter === 'ablauf') return v.haltbarkeit && v.haltbarkeit <= in7.toISOString().split('T')[0];
    return true;
  });

  const inp = { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box', marginBottom: '10px' };

  const niedrigAnzahl = vorrat.filter(v => v.menge <= v.mindestbestand).length;
  const ablaufAnzahl = vorrat.filter(v => v.haltbarkeit && v.haltbarkeit <= in7.toISOString().split('T')[0]).length;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '700' }}>📦 Vorratskammer</h1>
        <div style={{ display: 'flex', gap: '8px' }}>
          {niedrigAnzahl > 0 && <button onClick={autoEinkauf} style={{ padding: '8px 12px', background: '#fef3c7', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: '#92400e' }}>🛒 {niedrigAnzahl} nachkaufen</button>}
          <button onClick={kameraScanner} style={{ padding: '10px 14px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontSize: '18px' }}>📷</button>
          <button onClick={() => setZeigForm(true)} style={{ padding: '10px 14px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>+ Neu</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', overflowX: 'auto' }}>
        {[['alle','📦 Alle', vorrat.length], ['niedrig',`⚠️ Niedrig`,niedrigAnzahl], ['ablauf',`⏰ Ablauf`,ablaufAnzahl]].map(([v,l,n]) => (
          <button key={v} onClick={() => setFilter(v)}
            style={{ padding: '8px 14px', border: 'none', borderRadius: '99px', cursor: 'pointer', fontSize: '13px', fontWeight: filter===v?'700':'400',
              background: filter===v?'#6366f1':'#f1f5f9', color: filter===v?'white':'#374151', whiteSpace: 'nowrap' }}>
            {l} {n > 0 && <span style={{ background: filter===v?'rgba(255,255,255,0.3)':'#e2e8f0', borderRadius: '99px', padding: '1px 6px', fontSize: '11px' }}>{n}</span>}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {gefilter.map(v => {
          const istNiedrig = v.menge <= v.mindestbestand;
          const istAbgelaufen = v.haltbarkeit && v.haltbarkeit < heute;
          const laeuftAb = v.haltbarkeit && v.haltbarkeit <= in7.toISOString().split('T')[0] && !istAbgelaufen;
          return (
            <div key={v.id} style={{ background: 'white', borderRadius: '14px', padding: '14px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              borderLeft: `4px solid ${istAbgelaufen?'#ef4444':laeuftAb?'#f59e0b':istNiedrig?'#f59e0b':v.kategorie_farbe||'#6366f1'}` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                    <span>{v.kategorie_icon || '📦'}</span>
                    <span style={{ fontWeight: '700', fontSize: '15px' }}>{v.name}</span>
                    {istAbgelaufen && <span style={{ background: '#fee2e2', color: '#ef4444', padding: '1px 6px', borderRadius: '99px', fontSize: '10px', fontWeight: '700' }}>ABGELAUFEN</span>}
                    {laeuftAb && <span style={{ background: '#fef3c7', color: '#92400e', padding: '1px 6px', borderRadius: '99px', fontSize: '10px', fontWeight: '700' }}>LÄUFT AB</span>}
                  </div>
                  {v.marke && <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '4px' }}>{v.marke}</div>}
                  <div style={{ display: 'flex', gap: '8px', fontSize: '11px', color: '#94a3b8' }}>
                    {v.haltbarkeit && <span>📅 {new Date(v.haltbarkeit).toLocaleDateString('de-DE')}</span>}
                    {v.lagerort && <span>📍 {v.lagerort}</span>}
                    {v.preis && <span>💰 {eur(v.preis)}</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <button onClick={() => mengeAendern(v.id, -1)} style={{ width: '28px', height: '28px', borderRadius: '50%', border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
                    <span style={{ fontWeight: '700', fontSize: '16px', minWidth: '40px', textAlign: 'center', color: istNiedrig?'#ef4444':'#1e293b' }}>{v.menge} <span style={{ fontSize: '11px', fontWeight: '400', color: '#94a3b8' }}>{v.einheit}</span></span>
                    <button onClick={() => mengeAendern(v.id, 1)} style={{ width: '28px', height: '28px', borderRadius: '50%', border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
                  </div>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    <button onClick={() => bearbeiten(v)} style={{ background: '#f1f5f9', border: 'none', borderRadius: '6px', cursor: 'pointer', padding: '4px 8px', fontSize: '12px' }}>✏️</button>
                    <button onClick={() => loeschen(v.id)} style={{ background: '#fee2e2', border: 'none', borderRadius: '6px', cursor: 'pointer', padding: '4px 8px', fontSize: '12px' }}>🗑️</button>
                  </div>
                </div>
              </div>
              {istNiedrig && <div style={{ marginTop: '8px', fontSize: '11px', color: '#f59e0b', fontWeight: '600' }}>⚠️ Mindestbestand: {v.mindestbestand} {v.einheit}</div>}
            </div>
          );
        })}
      </div>

      {gefilter.length === 0 && <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}><div style={{ fontSize: '48px' }}>📦</div><div style={{ marginTop: '12px' }}>Nichts gefunden</div></div>}

      {zeigScanner && (
        <div style={{ position: 'fixed', inset: 0, background: 'black', zIndex: 200, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <p style={{ color: 'white', marginBottom: '12px', fontSize: '16px' }}>📷 Barcode scannen...</p>
          <video ref={videoRef} style={{ width: '100%', maxWidth: '400px', height: '300px', background: '#111' }} muted playsInline autoPlay />
          <button onClick={() => { if (window._zxingReaderVorrat) { window._zxingReaderVorrat.reset(); window._zxingReaderVorrat = null; } setZeigScanner(false); }}
            style={{ marginTop: '20px', padding: '12px 24px', background: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700' }}>Abbrechen</button>
        </div>
      )}

      {zeigForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: 'white', borderRadius: '20px 20px 0 0', padding: '24px', width: '100%', maxWidth: '600px', margin: '0 auto', maxHeight: '90vh', overflowY: 'auto' }}>
            <h2 style={{ margin: '0 0 16px', fontSize: '18px' }}>{bearbeite ? '✏️ Bearbeiten' : '➕ Neues Produkt'}</h2>
            <form onSubmit={speichern}>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
                <button type="button" onClick={() => { setZeigForm(false); setBearbeite(null); }}
                  style={{ flex: 1, padding: '14px', background: '#f1f5f9', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '600', fontSize: '15px' }}>✕ Abbrechen</button>
                <button type="submit"
                  style={{ flex: 2, padding: '14px', background: '#6366f1', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: '700', fontSize: '15px' }}>💾 Speichern</button>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
                <input style={{ ...inp, flex: 3, marginBottom: 0 }} placeholder="Produktname *" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
                <input style={{ ...inp, flex: 1, marginBottom: 0 }} placeholder="Barcode" value={form.barcode}
                  onChange={e => setForm({...form, barcode: e.target.value})}
                  onBlur={() => barcodeEingabe(form.barcode)} />
              </div>
              <input style={inp} placeholder="Marke" value={form.marke} onChange={e => setForm({...form, marke: e.target.value})} />
              <select style={inp} value={form.kategorie_id} onChange={e => setForm({...form, kategorie_id: e.target.value})}>
                <option value="">-- Kategorie --</option>
                {kategorien.map(k => <option key={k.id} value={k.id}>{k.icon} {k.name}</option>)}
              </select>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                <div><label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '4px' }}>Menge</label>
                  <input style={{ ...inp, marginBottom: 0 }} type="number" step="0.1" min="0" value={form.menge} onChange={e => setForm({...form, menge: e.target.value})} /></div>
                <div><label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '4px' }}>Einheit</label>
                  <select style={{ ...inp, marginBottom: 0 }} value={form.einheit} onChange={e => setForm({...form, einheit: e.target.value})}>
                    {['Stück','kg','g','l','ml','Packung','Flasche','Dose','Beutel'].map(u => <option key={u}>{u}</option>)}
                  </select></div>
                <div><label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '4px' }}>Mindestbestand</label>
                  <input style={{ ...inp, marginBottom: 0 }} type="number" step="0.1" min="0" value={form.mindestbestand} onChange={e => setForm({...form, mindestbestand: e.target.value})} /></div>
                <div><label style={{ fontSize: '12px', color: '#64748b', display: 'block', marginBottom: '4px' }}>Haltbarkeit</label>
                  <input style={{ ...inp, marginBottom: 0 }} type="date" value={form.haltbarkeit} onChange={e => setForm({...form, haltbarkeit: e.target.value})} /></div>
              </div>
              <input style={inp} placeholder="Lagerort (z.B. Keller, Kühlschrank)" value={form.lagerort} onChange={e => setForm({...form, lagerort: e.target.value})} />
              <input style={inp} type="number" step="0.01" placeholder="Preis (€)" value={form.preis} onChange={e => setForm({...form, preis: e.target.value})} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                <input type="checkbox" id="auto" checked={form.auto_einkauf} onChange={e => setForm({...form, auto_einkauf: e.target.checked})} />
                <label htmlFor="auto" style={{ fontSize: '14px', fontWeight: '600' }}>🛒 Automatisch auf Einkaufsliste wenn niedrig</label>
              </div>

            </form>
          </div>
        </div>
      )}
    </div>
  );
}
